<template>
  <div class="Rtable-row">
    <div class="Rtable-cell cb-cell">
      <div class="Rtable-cell--heading">SELECT</div>
      <!--      <div class="Rtable-cell&#45;&#45;content date-content"><span class="webinar-date">August 2nd, 2016</span><br />6:00 pm (CDT)</div>-->
      <div class="Rtable-cell--content date-content">
        <input type="checkbox" />
      </div>
    </div>
    <div class="Rtable-cell id-cell">
      <div class="Rtable-cell--heading">ID</div>
      <div class="Rtable-cell--content title-content">{{ order.id }}</div>
    </div>
    <div class="Rtable-cell contact-cell">
      <div class="Rtable-cell--heading">Contact</div>
      <div class="Rtable-cell--content title-content">{{ order.contact_id }}</div>
    </div>
    <div class="Rtable-cell status-cell">
      <div class="Rtable-cell--heading">Status</div>
      <div class="Rtable-cell--content access-link-content">{{ order.status.status }}</div>
    </div>
    <div class="Rtable-cell types-cell">
      <div class="Rtable-cell--heading">TYPE</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.types[0].type }}</div>
    </div>
<!--    <div class="Rtable-cell photos-cell">-->
<!--      <div class="Rtable-cell&#45;&#45;heading">Photos</div>-->
<!--      <div class="Rtable-cell&#45;&#45;content replay-link-content">{{ order.photos }}</div>-->
<!--    </div>-->
    <div class="Rtable-cell kind-cell">
      <div class="Rtable-cell--heading">Kind</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.order_kind }}</div>
    </div>
    <div class="Rtable-cell language-cell">
      <div class="Rtable-cell--heading">Language</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.language_id }}</div>
    </div>
    <div class="Rtable-cell country-cell">
      <div class="Rtable-cell--heading">Country</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.country_id }}</div>
    </div>

    <div class="Rtable-cell overall-cell">
      <div class="Rtable-cell--heading">Overall Price</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.overall_price }}</div>
    </div>

    <div class="Rtable-cell price_plus_vat-cell">
      <div class="Rtable-cell--heading">Price + VAT</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.price_plus_vat }}</div>
    </div>

    <div class="Rtable-cell discount-cell">
      <div class="Rtable-cell--heading">Discount</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.discount }}</div>
    </div>

    <div class="Rtable-cell price_after_discount-cell">
      <div class="Rtable-cell--heading">P.after discount</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.price_after_discount }}</div>
    </div>

    <div class="Rtable-cell projected_job_span-cell">
      <div class="Rtable-cell--heading">projected job time</div>
      <div class="Rtable-cell--content replay-link-content">{{ order.projected_job_span }}</div>
    </div>

    <div class="Rtable-cell order_date-cell">
      <div class="Rtable-cell--heading">Order Date</div>
      <div class="Rtable-cell--content replay-link-content">{{ formatDate(order.order_date) }}</div>
    </div>

    <div class="Rtable-cell projected_finish_date-cell">
      <div class="Rtable-cell--heading">P. finish time</div>
      <div class="Rtable-cell--content replay-link-content">{{formatDate(order.projected_finish_date) }}</div>
    </div>
    <div class="Rtable-cell created_at-cell">
      <div class="Rtable-cell--heading">Created At</div>
      <div class="Rtable-cell--content replay-link-content">{{formatDate(order.created_at) }}</div>
    </div>
    <div class="Rtable-cell tags-cell">
      <div class="Rtable-cell--heading">Tags</div>
      <div class="Rtable-cell--content replay-link-content">
        <orders-tags :tags="[{ data:{}, tagType: 'process'}]" :tagSector="'orders'"></orders-tags>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import ContactTags from "@/features/projects.feature/contacts/containers/ContactTags.container";
// import ContactAddTag from "@/features/projects.feature/contacts/components/ContactAddTag.component";
import OrdersTags from "../containers/OrdersTags.container"

export default {
  name: "Order.component",
  props: {
    order: {
      type: Object
    },
    columnSize: {
      type: Object
    }
  },
  components: {
    OrdersTags
  },

  methods:{
    formatDate(date){
      return moment(date).format("DD/MM/YYYY");

    }
  },

  computed: {}
};
</script>

<style scoped lang="scss">
$breakpoint: 750px;
$heading-color: #43bac0;

* {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  //max-width: 1000px;
  //margin: 1em auto;
  //padding: 1em;
}

.is-striped {
  background-color: rgba(233, 200, 147, 0.2);
}

/* Table column sizing
================================== */
.cb-cell {
  width: 2%;
}
.id-cell {
  width: 2%;
}
.contact-cell {
  width: 3.4%;
}

.status-cell {
  width: 3.4%;
}
.types-cell {
  width: 3.4%;
}

/*.photos-cell {
  width: 6.4%;
}*/
.kind-cell {
  width: 3.4%;
}
.language-cell {
  width: 3.4%;
}

.country-cell {
  width: 3.4%;
}
.order_date-cell {
  width: 3.4%;
}
.created_at-cell {
  width: 3.4%;
}
.tags-cell {
  width: 50%;
}


.overall-cell {
  width: 3.4%;
}
.price_plus_vat-cell {
  width: 3.4%;
}

.discount-cell {
  width: 3.4%;
}
.price_after_discount-cell {
  width: 3.4%;
}
.projected_job_span-cell {
  width: 3.4%;
}
.projected_finish_date-cell {
  width: 3.4%;
}

/* Apply styles
================================== */
.Rtable {
  display: flex;
  flex-wrap: wrap;
  //margin: 0 0 3em 0;
  padding: 0;
  //box-shadow: 0 0 40px rgba(0,0,0,0.2);

  .Rtable-row {
    width: 100%;
    display: flex;

    .Rtable-cell {
      box-sizing: border-box;
      flex-grow: 1;
      //padding: 0.8em 1.2em;
      padding: 0.26%;
      overflow: hidden; // Or flex might break
      list-style: none;

      &.column-heading {
        background-color: $heading-color;
        color: white;
        padding: 1em;
      }

      .Rtable-cell--heading {
        display: none;
      }

      .Rtable-cell--content {
        text-align: center;
        font-size: 13px;
        a {
          font-size: 2em;
          color: #333;
        }

        .webinar-date {
          font-weight: 700;
        }
      }
    }
  }
}

/* Responsive
==================================== */
@media all and (max-width: $breakpoint) {
  .is-striped {
    background-color: white;
  }

  .Rtable--collapse {
    display: block;
    width: 100%;
    padding: 1em;
    box-shadow: none;

    .Rtable-row {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2em;
      box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

      .Rtable-cell {
        width: 100% !important;
        display: flex;
        align-items: center;

        .Rtable-cell--heading {
          display: inline-block;
          flex: 1;
          max-width: 120px;
          min-width: 120px;
          color: $heading-color;
          font-weight: 700;
          border-right: 1px solid #ccc;
          margin-right: 1em;
        }

        .Rtable-cell--content {
          flex: 2;
          padding-left: 1em;
        }
      }
    }

    .topic-cell {
      background-color: $heading-color;
      color: white;
      font-weight: 700;
      order: -1;

      .Rtable-cell--content {
        padding-left: 0 !important;
      }
    }

    .Rtable-row--head {
      display: none;
    }
  }
}

// Non-Flex modernizer fallback
.no-flexbox .Rtable {
  display: block;

  &.Rtable-cell {
    width: 100%;
  }
}
</style>
